import { useState, useEffect } from 'react';
import { Box, Button, Typography, Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton, Avatar, ButtonBase } from '@mui/material';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { useAuth } from '../../AuthContext';
import { tokens } from '../../theme';
import { useTheme } from '@mui/material';
import { toast } from 'react-toastify';
import MessageIcon from '@mui/icons-material/Message';
import SendIcon from '@mui/icons-material/Send';
import { Form } from 'react-bootstrap';
import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import DraftsOutlinedIcon from '@mui/icons-material/DraftsOutlined';
import MarkunreadOutlinedIcon from '@mui/icons-material/MarkunreadOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';

const Chats = ({ userId, params }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box mt={4} width={'100%'} height={'65vh'} sx={{overflowX: 'hidden', overflowY: 'auto'}}>
        {params.map( message =>
            message.sender === userId ? (
                <Box key={message.id} width={'100%'} display={'flex'} flexDirection={'column'} alignItems={'end'} justifyContent={'end'}
                    marginBottom={'.5rem'}>
                    <Box sx={{backgroundColor: colors.primary[400]}} width={'300px'} padding={'1rem'} borderRadius={'1rem 1rem 0 1rem'} marginRight={'10px'} marginBottom={'.5rem'}>
                        <Typography>{message.message}</Typography>
                    </Box>
                    <Typography>{message.sendDate}</Typography>
                </Box>
            ):(
                <Box key={message.id} width={'100%'} display={'flex'} flexDirection={'column'} alignItems={'start'} 
                    justifyContent={'start'} marginBottom={'.5rem'} >
                    <Box sx={{backgroundColor: colors.primary[100]}} width={'300px'} padding={'1rem'} borderRadius={'1rem 1rem 1rem 0'} marginLeft={'10px'} marginBottom={'.5rem'}>
                        <Typography color='darkblue'>{message.message}</Typography>
                    </Box>
                    <Typography>{message.sendDate}</Typography>
                </Box>
            )
        )}
    </Box>
  );
};

export default Chats;